import { type EmptyObject, moneyFormatNoDecimal, Stack, Text, useText } from "@sveabank/cc-common";
import { type ProductDefinitionId } from "../../types/product";
import BulletListItem from "../bullet-list/list-item";
import type { SelectedAddonsRecord } from "./product-section";

type Props = {
	selectedAddons: EmptyObject | SelectedAddonsRecord;
	product: ProductDefinitionId;
};

const ProductItemHeading = ({ selectedAddons, product }: Props) => {
	const [t, texts] = useText();
	const addon = selectedAddons[product];
	const sku = addon.product.sku;

	return (
		<BulletListItem variant="small" icon="CHECKMARK">
			<Stack key={product} justify="between" direction="row">
				<span>{`${addon.count} ${t(texts.addons[sku]?.title)}`}</span>
				<Text className="text-text-headline">{`${moneyFormatNoDecimal(
					Number(addon.product.monthlyFee.amount) * addon.count,
					true,
				)}${t(texts.common.perMonth)}`}</Text>
			</Stack>
		</BulletListItem>
	);
};

export default ProductItemHeading;
